<template>
  <div v-if="obj">
    <van-popup v-model="visible" position="top" class="HideScrollbar">
      <div class="main">
        <h1>
          <el-button class="back" type="text" icon="el-icon-back" @click="onCancel" />
          {{ obj.DispName }} ${{ obj.Price1 }}
          <!-- {{ obj }} -->
        </h1>

        <!-- {{ obj }} -->
        <van-image :src="obj.ImgFile" lazy-load width="200" />
        <div v-html="gNl2br(gGetIcon(obj.Remark))" />

        <!-- GROUPS -->
        <div v-for="lv in obj.Groups" :key="lv.key">
          <van-divider />
          <h3>{{ lv.text }} {{ lv.type }}</h3>
          <div class="tab" v-for="s2 in lv.options" :key="s2.ItemName">
            <div v-if="haveGroups(s2)">
              <el-button type="text" @click="showDetailGroup(s2.Groups, s2.DispName)"
                >{{ s2.DispName }} ${{ s2.Price1 }}</el-button
              >
            </div>
            <div v-else>{{ s2.DispName }} ${{ s2.Price1 }}</div>
          </div>
        </div>

        <!-- NEXT (For Woosa) -->
        <div v-if="obj.Next">
          <van-divider />
          <h3>{{ obj.Next.text }} {{ obj.Next.type }}</h3>
          <div class="tab" v-for="s2 in obj.Next.options" :key="s2.ItemName">
            <div v-if="haveGroups(s2)">
              <el-button type="text" @click="showDetailGroup(s2.Groups, s2.DispName)"
                >{{ s2.DispName }} ${{ s2.Price1 }}</el-button
              >
            </div>
            <div v-else>{{ s2.DispName }} ${{ s2.Price1 }}</div>
          </div>
        </div>
      </div>
      <FrmItemDetailGroup ref="rItemDetailGroup" />
    </van-popup>
  </div>
</template>

<style scoped>
.el-button {
  font-size: 1rem;
}
.tab {
  margin-left: 2rem;
}
.back {
  font-size: 2rem;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  /* font-size: 1.6rem; */
  line-height: 2.4rem;
  padding: 1rem;
  text-align: left;
}
</style>

<script>
export default {
  data() {
    return {
      visible: false,
      obj: null,
      objString: "",
      bkmenu: null,
      options: [],
    };
  },
  methods: {
    showDetailGroup(groups, title) {
      // console.log("showDetailGroup", groups);
      console.log("!1");
      this.$refs.rItemDetailGroup.show(groups, title);
    },
    haveGroups(obj) {
      if (obj.Groups == undefined) {
        return false;
      }
      if (obj.Groups.length == 0) {
        return false;
      }
      return true;
    },
    addOptions() {
      this.options.forEach((r) => {
        // let row = {};
        // r = JSON.parse(r);
        // row.TypeNo = r.TypeNo;
        // row.ItemName = r.ItemName;
        // row.KPtype = r.KPtype;
        // row.ItemCode = r.ItemCode;
        // row.Price1 = r.Price1;

        this.obj.groups.push(r);
      });
      this.options = [];
    },
    onPick(row, url) {
      console.log("pick", row, url);
      this.obj.imgfile = url;
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        this.options = [];
      } catch (error) {
        console.log(error.toString());
      }
    },
    async show(obj) {
      this.gLoading();
      // console.log("show", obj);
      var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
      console.log(query);
      var res = await this.apiMpoItemc(query);
      // this.obj = res.data;
      console.log(res.data);
      this.obj = obj;
      this.obj = res.data;
      this.visible = true;
      this.gClearLoading();
    },
    // async getItemc(obj) {
    //   var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
    //   var res = await this.apiMpoItemc(query);
    //   // console.log(res.data);
    //   // this.gMsgbox(JSON.stringify(res.data));
    //   this.obj = res.data;
    //   return res.data;
    // },
    // async showEdit(rowIndex, obj) {
    //   try {
    //     await this.init();
    //     console.log("show", rowIndex);
    //     var find = this.bkmenu.extitem.find((r) => r.itemname == obj.ItemName);
    //     if (find) {
    //       // update
    //       this.objString = JSON.stringify(find);
    //       this.obj = JSON.parse(this.objString);
    //       this.visible = true;
    //       console.log("old", find);
    //     } else {
    //       // create new
    //       console.log("new", obj.ItemName);
    //       this.obj = {
    //         itemname: obj.ItemName,
    //         dispname: "",
    //         imgfile: "",
    //         desp: "",
    //         groups: [],
    //       };
    //       this.visible = true;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    close() {
      this.obj = null;
      this.visible = false;
    },
    onCancel() {
      // this.obj = JSON.parse(this.objString);
      // console.log("string", this.objString);
      // console.log("objobj", JSON.stringify(this.obj));
      this.visible = false;
    },
    async onOk() {
      var body = this.obj;
      var res = await this.apiUpdateExtitem(body);
      console.log("res", res);
      this.visible = false;
      this.$emit("ok");
      this.obj = null;
    },
    async handleDelete(rowIndex) {
      this.obj.groups.splice(rowIndex, 1);
    },
  },
};
</script>
